import { useMutation } from '@tanstack/react-query';
import { useBffClient } from './client';
import type { DetectionTestRequest, DetectionTestResponse } from '../types/detection';

export function useTestDetection() {
  const client = useBffClient();
  return useMutation({
    mutationFn: (request: DetectionTestRequest) =>
      client.post<DetectionTestResponse>('/bff/detect/test', request),
  });
}
